import React from "react";
import { v4 as uuidv4 } from "uuid";
import { FiType } from "react-icons/fi";
import { WidgetContextProvider } from "./context";
import { ControlPanel } from "./ControlPanel";
import { PreviewPlayer } from "./PlayerPreview";
import { PlayerDevice } from "./Player";
import { initialSlateValue } from "../utils/slate";
export const TextWidget = {
    id: "sqd-sqd-cwx-bvhg-fghfgh-qw",
    name: "Text",
    icon: React.createElement(FiType, null),
    type: "text",
    inHeadbar: true,
    description: "Edit text (font, size, color, etc.)",
    config: null,
    createdAt: "2022-06-12T08:09:00.000Z",
    updatedAt: "2022-06-12T08:09:00.000Z",
    isActive: true,
    isDeleted: false,
    load: null,
    scope: ["font"],
    controlPanel: ControlPanel,
    playerPreview: PreviewPlayer,
    context: WidgetContextProvider,
    playerDevice: PlayerDevice,
    contextDevice: ({ children }) => React.createElement(React.Fragment, null, children),
    factory: () => ({
        id: uuidv4(),
        data: {
            text: initialSlateValue,
            backgroundColor: "#FFFFFF00",
            color: "#FFFFFF",
        },
    }),
    height: "auto",
    width: "auto",
    resize: {
        bottom: false,
        bottomLeft: true,
        bottomRight: true,
        left: true,
        right: true,
        top: false,
        topLeft: true,
        topRight: true,
    },
};
